<template>
  <div class="dashboard">
    <van-nav-bar title="工作台" :border="false" />
    <!-- 用户信息 -->
    <div class="dd-card user-card">
      <div class="avatar">{{ (userInfo.nickName||'U')[0] }}</div>
      <div class="user-info"><div class="name">{{ userInfo.nickName || '用户' }}</div><div class="dept">{{ userInfo.authority || '管理员' }}</div></div>
    </div>
    <!-- 常用应用 -->
    <div class="dd-section-title">常用应用</div>
    <div class="dd-card app-grid">
      <div class="app-item" @click="$router.push('/oa-punch')"><div class="app-icon" style="background:#2F88FF"><van-icon name="underway-o" /></div><span>考勤打卡</span></div>
      <div class="app-item" @click="$router.push('/oa-leave')"><div class="app-icon" style="background:#00B578"><van-icon name="edit" /></div><span>请假</span></div>
      <div class="app-item" @click="$router.push('/bill')"><div class="app-icon" style="background:#FF943E"><van-icon name="orders-o" /></div><span>话单</span></div>
      <div class="app-item" @click="$router.push('/customer-resource')"><div class="app-icon" style="background:#7B61FF"><van-icon name="friends-o" /></div><span>客资</span></div>
      <div class="app-item" @click="$router.push('/ip-whitelist')"><div class="app-icon" style="background:#3491FA"><van-icon name="shield-o" /></div><span>白名单</span></div>
    </div>
    <!-- 今日考勤快报 -->
    <div class="dd-section-title">今日考勤</div>
    <div class="dd-card punch-brief" v-if="punchBrief">
      <div class="brief-item"><div class="brief-label">上班</div><div class="brief-val" :class="{done:punchBrief.punchIn}">{{ punchBrief.punchIn || '未打卡' }}</div></div>
      <div class="brief-divider"></div>
      <div class="brief-item"><div class="brief-label">下班</div><div class="brief-val" :class="{done:punchBrief.punchOut}">{{ punchBrief.punchOut || '未打卡' }}</div></div>
    </div>
    <div class="dd-card" style="text-align:center;color:#A0A4AE;padding:32px 0" v-else><van-icon name="underway-o" size="36" /><p style="margin-top:8px">暂无考勤数据</p></div>
  </div>
</template>

<script>
import { oaGetTodayPunch } from '@/api'
export default {
  name: 'Dashboard',
  data() { return { punchBrief: null, userInfo: {} } },
  computed: { user() { return this.$store.getters['user/userInfo'] } },
  created() { this.userInfo = this.user || {}; this.loadPunch() },
  methods: {
    async loadPunch() {
      try { const res = await oaGetTodayPunch(); if(res.code===0){ const list=res.data.list||[]; const b={punchIn:'',punchOut:''}; list.forEach(r=>{if(r.type==='上班')b.punchIn=r.punch_time.slice(11,19);if(r.type==='下班')b.punchOut=r.punch_time.slice(11,19)}); this.punchBrief=b } } catch(e) {}
    }
  }
}
</script>

<style scoped>
.dashboard { min-height:100vh; background:#F5F6FA; }
.user-card { display:flex; align-items:center; gap:14px; margin-top:8px; }
.avatar { width:48px; height:48px; border-radius:14px; background:#2F88FF; color:#fff; display:flex; align-items:center; justify-content:center; font-size:20px; font-weight:700; flex-shrink:0; }
.user-info .name { font-size:17px; font-weight:600; color:#171A1D; }
.user-info .dept { font-size:12px; color:#A0A4AE; margin-top:2px; }
.app-grid { display:flex; flex-wrap:wrap; padding:12px 0 4px; }
.app-item { width:25%; display:flex; flex-direction:column; align-items:center; margin-bottom:16px; cursor:pointer;
  span { font-size:12px; color:#666B78; margin-top:6px; }
}
.app-icon { width:44px; height:44px; border-radius:12px; display:flex; align-items:center; justify-content:center; color:#fff; font-size:22px; }
.punch-brief { display:flex; align-items:center; }
.brief-item { flex:1; text-align:center; }
.brief-label { font-size:12px; color:#A0A4AE; margin-bottom:4px; }
.brief-val { font-size:18px; font-weight:700; color:#171A1D; font-family:'Courier New',monospace; &.done { color:#00B578; } }
.brief-divider { width:1px; height:36px; background:#E8E8EC; }
</style>
